export default "__VITE_ASSET__CgLt9x0q__"